import { HttpErrorResponse } from '@angular/common/http';

export function httpTitleResponseToText(err: HttpErrorResponse): string {
  return 'Hubo un problema';
  const errorCode = err?.error?.title || err?.status?.toString();
  const errorTitles: Record<string, string> = {
    'DetailCatalog.NotEnoughQuantity': 'Stock insuficiente',
    'Carts.InsufficientPoints': 'No se pudo agregar el artículo',
    '500': 'Error del servidor',
  };

  return errorTitles[errorCode] || err?.error?.title || 'Hubo un problema';
}
